module.exports = __webpack_public_path__ + "img/icon_vues.bf0150fb.svg";